export default __webpack_public_path__ + "static/media/payment_failed.e19b0aff.gif";